export const ChatType = Object.freeze({
	user: 'user',
	chat: 'chat',
	open: 'open',
	general: 'general',
	videoconf: 'videoconf',
	announcement: 'announcement',
	call: 'call',
	support24Notifier: 'support24Notifier',
	support24Question: 'support24Question',
	crm: 'crm',
	sonetGroup: 'sonetGroup',
	calendar: 'calendar',
	tasks: 'tasks',
	taskComments: 'tasksTask',
	thread: 'thread',
	mail: 'mail',
	lines: 'lines',
	copilot: 'copilot',
	channel: 'channel',
	openChannel: 'openChannel',
	generalChannel: 'generalChannel',
	comment: 'comment',
	collab: 'collab',
});

export type ChatTypeItem = $Values<typeof ChatType>;

export const DialogScrollThreshold = Object.freeze({
	none: 'none',
	nearTheBottom: 'nearTheBottom',
	halfScreenUp: 'halfScreenUp',
});

export const DialogBlockType = Object.freeze({
	dateGroup: 'dateGroup',
	authorGroup: 'authorGroup',
	newMessages: 'newMessages',
	markedMessages: 'markedMessages',
});

export const DialogAlignment = Object.freeze({
	left: 'left',
	center: 'center',
});

export const DialogIdChatPrefix = 'chat';

export const TempAiAssistantPrefix = 'temp-ai-assistant';
